import React from 'react';
import { List, ListItemText, Collapse, ListItemButton } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import { NotificationsList } from './notifications-list.component';
import { NotificationsButtonContext } from './notifications-button.context';

function NotificationsSections({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}): JSX.Element {
  const { isSuggestion, defaultOpen } = React.useContext(NotificationsButtonContext);
  const [open, setOpen] = React.useState(defaultOpen);
  const handleClick = (): void => setOpen((prev) => !prev);
  const color = isSuggestion ? 'info.dark' : 'error.dark';

  return (
    <List sx={{ p: 0 }}>
      <ListItemButton onClick={handleClick}>
        <ListItemText primary={title} sx={{ color: color }} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout='auto' unmountOnExit>
        {children}
      </Collapse>
    </List>
  );
}

NotificationsSections.List = NotificationsList;

export { NotificationsSections };
